import React from 'react';
import { FaLock, FaUserShield } from 'react-icons/fa';
import { useWallet } from '../../context/WalletContext';
import '../../styles/global.css';

function Security() {
  const { dolphinContract, isAdmin } = useWallet();
  const [newOwner, setNewOwner] = React.useState('');
  const [txLoading, setTxLoading] = React.useState(false);
  const [error, setError] = React.useState(null);
  const [ownerAddress, setOwnerAddress] = React.useState('');

  React.useEffect(() => {
    const fetchOwner = async () => {
      if (dolphinContract) {
        try {
          const owner = await dolphinContract.owner();
          setOwnerAddress(owner);
        } catch (err) {
          setOwnerAddress('');
        }
      }
    };
    fetchOwner();
  }, [dolphinContract]);


  return (
    <div className="featured-stat-card">
      <div className="featured-stat-header">
        <span className="featured-stat-icon">
          <FaLock />
        </span>
        <span className="featured-stat-label">Security</span>
      </div>
      <div className="featured-stat-value">
        Contract Owner: <span className="security-owner-address">{ownerAddress ? ownerAddress : '--'}</span>
        {isAdmin && <span className="security-owner-badge">(You are an admin)</span>}
      </div>
      <div className="price-range-bar">
        <div className="price-range-fill" style={{ width: `100%` }}></div>
      </div>
      <div className="price-range-labels">
        <span>Admin</span>
        <span>{ownerAddress ? ownerAddress : '--'}</span>
        <span>Transfer</span>
      </div>
      <div className="security-transfer-row">
        <input
          className="security-owner-input"
          type="text"
          placeholder="New owner address"
          value={newOwner}
          onChange={e => setNewOwner(e.target.value)}
        />
        <button
          className="btn btn-primary security-owner-btn"
          disabled={txLoading || !newOwner}
          onClick={async () => {
            setError(null);
            setTxLoading(true);
            try {
              if (!dolphinContract) throw new Error('Contract not connected');
              const tx = await dolphinContract.transferOwnership(newOwner);
              await tx.wait();
              setNewOwner('');
            } catch (err) {
              setError(err.message || 'Failed to transfer ownership');
            } finally {
              setTxLoading(false);
            }
          }}
        >
          {txLoading ? 'Transferring...' : <><FaUserShield style={{marginRight:6}}/> Transfer Ownership</>}
        </button>
      </div>
      {error && <div style={{color:'#ef4444',marginTop:'0.7rem'}}>{error}</div>}
    </div>
  );
}

export default Security;
